<ng-container *ngFor="let pet of activePetDetails">
	<section
		*ngIf="!!pet.providers && !pet.providers.length && pet.isInsured"
		class="notification"
	>
		<section class="notification__indicator">
			<svg
				width="21"
				height="21"
				viewBox="0 0 21 21"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					d="M20.003 10.89a9.585 9.585 0 0 1-1.371 5 9.794 9.794 0 0 1-3.63 3.63 9.585 9.585 0 0 1-5 1.37 9.586 9.586 0 0 1-5-1.37 10.104 10.104 0 0 1-3.668-3.63 9.806 9.806 0 0 1-1.331-5c0-1.8.443-3.467 1.33-5a10.104 10.104 0 0 1 3.67-3.628 9.585 9.585 0 0 1 5-1.371c1.801 0 3.468.457 5 1.37a9.794 9.794 0 0 1 3.629 3.63 9.586 9.586 0 0 1 1.37 5zm-10 2.017c-.51 0-.954.188-1.33.564-.35.35-.525.78-.525 1.29 0 .511.175.955.524 1.331.377.35.82.524 1.33.524.512 0 .942-.174 1.291-.524a1.82 1.82 0 0 0 .565-1.33c0-.511-.188-.941-.565-1.29a1.692 1.692 0 0 0-1.29-.565zM8.229 6.254l.322 5.483c0 .108.04.216.121.323a.59.59 0 0 0 .363.12h1.936c.134 0 .242-.04.322-.12.108-.107.162-.215.162-.323l.322-5.483c0-.162-.054-.283-.161-.363a.383.383 0 0 0-.323-.162h-2.58a.501.501 0 0 0-.363.162c-.08.08-.121.201-.121.363z"
					fill="#fff"
				/>
			</svg>
		</section>
		<section class="notification__copy">
			<strong>Required Information:</strong> Add vet clinic details for {{ pet.petName }}
		</section>
		<section class="notification__action">
			<button
				class="notification__action-item"
				(click)="handleAddVet(pet.id)"
			>Add Vet Clinic</button>
		</section>
	</section>
</ng-container>